import { Dao } from '@platform/entities/dao.class';
import type { EntityType } from '@platform/entities/entity.class';
import { EmployeeProjectEntity } from '@platform/entities/employee_project/employee_project.entity';
import { NodeAPI } from '@platform/shared/rpc';

export class EmployeeProjectDao extends Dao<EmployeeProjectEntity, typeof EmployeeProjectEntity> {
    protected async load(
        params: {
            sqlFilter?: string | null;
            fields?: string[];
            id?: string | null;
            commercialOfferStateIn?: string | null;
            requestRowId?: string | null;
        } & Record<string, any>
    ): Promise<EntityType<EmployeeProjectEntity>[]> {
        const query_response = await NodeAPI.Rpc.readWithRefs(EmployeeProjectEntity, {
            filters: params.sqlFilter ? [[params.sqlFilter.replace(/_main_table_/g, 'main_table')]] : undefined,
            // joins: [
            //     {
            //         ref: 'platform.project',
            //         alias: '_p_',
            //         on: "main_table.project_id = _p_.id and _p_.sys_row_status = 'ACT'",
            //         include: [
            //             ['name', 'project.label'],
            //             ['name', 'project.name'],
            //             ['id', 'project.value'],
            //             ['sys_doc_state', 'project.sys_doc_state'],
            //         ],
            //     },
            // ],
        });

        return query_response;
    }
}
